import { Navigate, useParams } from "react-router";

/** The story map is the editor (CONCEPT.md §13.7). `/edit` just redirects. */
export function StoryEditPage() {
  const { storyId = "" } = useParams();
  return <Navigate to={`/stories/${storyId}/map`} replace />;
}
